import { ISameCaseModel } from '../../../../interfaces/ISameCaseModel';
import { SameCasesCaseRow } from '../../../../components/quad/same-cases/view/SameCasesCaseRow';
import { Table } from 'react-bootstrap';

export interface IViewSameCaseTableProps {
    onEasyUpdateClick: (caseGuid: string) => void;
    sameCase: ISameCaseModel;
}

export function ViewSameCaseTable(props: IViewSameCaseTableProps) {
    return (
        <Table>
            <thead>
                <tr>
                    <th style={{ width: 30 }}/>
                    <th style={{ width: 200 }}>Case Number</th>
                    <th style={{ width: 200 }}>Case Name</th>
                    <th style={{ width: 200 }}>Jurisdiction</th>
                    <th />
                </tr>
            </thead>
            <tbody>
                <SameCasesCaseRow
                    key={
                        props.sameCase.caseNumber +
                        props.sameCase.jurisdiction +
                        props.sameCase.caseName
                    }
                    sameCase={props.sameCase}
                    onEasyUpdateClick={props.onEasyUpdateClick}
                    expandedByDefault
                    activeKeys={[]}
                    easyUpdateAttempted={false}
                />
            </tbody>
        </Table>
    );
}
